import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { OrganizationService } from 'src/app/private/services/organization.services';
import { SharedModule } from 'src/app/private/shared/shared.module';

@Component({
  selector: 'app-create-course',
  imports: [SharedModule],
  templateUrl: './create-course.component.html',
  styleUrl: './create-course.component.scss'
})
export class CreateCourseComponent {
  @Input() orgId!: string;
  @Input() campuses: any[] = [];
  @Input() departments: any[] = [];
  @Output() close = new EventEmitter<void>();
  @Output() reload = new EventEmitter<void>();

  handleCloseDialog() {
    this.close.emit();
  }

  courseForm: FormGroup;
  submitted = false;
  isLoading = false;

  campusOptions : any[] = [  ];

  deptOptions : any[] = [  ];

  statusOptions = [
    { label: 'Active', value: 'Active' },
    { label: 'Inactive', value: 'Inactive' }
  ];

  constructor(private fb: FormBuilder,
    private orgService: OrganizationService,
    private messageService: MessageService) {
    this.courseForm = this.fb.group({
      campus_id: [null, Validators.required],
      dept_id: [null],
      name: ['', Validators.required],
      description: [''],
      code: ['', Validators.required],
      duration: [null, [Validators.required, Validators.min(1)]],
      status: [null, Validators.required]
    });
  }

  
  ngOnInit(): void {
    this.campusOptions = this.campuses.map((campus) => ({
      label: campus.name,
      value: campus.campus_id
    }));
    this.deptOptions = this.departments.map((department) => ({
      label: department.name,
      value: department.dept_id
    }));
  }

  submitForm() {
    this.submitted = true;

    if (this.courseForm.valid) {
      this.isLoading = true;
      const payload = {
        ...this.courseForm.value,
        organization_id: this.orgId
      };
      this.orgService.createCourse(payload).subscribe({
        next: (data) => {
          console.log('Course created successfully:', data);
          this.reload.emit(); // Emit the reload event to refresh the course list
          this.handleCloseDialog();
          this.messageService.add({
            severity: 'success',
            summary: 'Success',
            detail: 'Course created successfully!'
          });
        },
        error: (err) => {
          console.error('Error creating course:', err);
        }
      });
    }
  }
}
